<template>
<div class="chapter">
<div class="inner_page">
<h2 class="calibre" id="pgepubid00044">CHAPTER IV</h2>
<h3 class="calibre8 sigil_not_in_toc" id="pgepubid00045">GRACE SURPRISES HER CHUMS</h3>
<p class="calibre3">"I'm not a pig," cried Grace, striving to look dignified, which is a
rather difficult procedure when one is being hugged by three pairs of
arms at once. "I don't care how many times you spit me, whatever that
is, Mollie, but you shan't call me a pig."</p>
<p class="calibre3">"Of course she shan't," said Betty soothingly. "If she does it again,
we'll try our hand at this spitting business—"</p>
<p class="calibre3">"Goodness, sounds like a cat fight," chuckled Grace, but Mollie
<ins class="calibre19" title="Transcriber's Note: original reads 'uncerimoniously'">unceremoniously</ins> shook her into attention.</p>
<p class="calibre3">"Grace, behave and tell us," she ordered.</p>
<p class="calibre3">"What?" asked Grace aggravatingly, but added hastily as Mollie again
raised the knitting needle at a threatening angle: "All right, if you'll
just give me space enough to breathe I'll do any little thing you ask."</p>
<p class="calibre3">With that the three jumped from the swing so suddenly that Grace, the
only occupant left,<span id="pgepubid00046" title="[28]"><a id="Page_28" title="[28]"></a></span> bounced into the air and landed with a thump on the
cushions.</p>
<p class="calibre3">They laughed and drew up three chairs in a semi-circle in front of her
to make escape impossible. Then three pairs of merry eyes focused
commandingly upon her.</p>
<p class="calibre3">"I didn't know it myself till last night," she said in response to the
tacit order. "Then it was patriotic Aunt Mary who proposed it."</p>
<p class="calibre3">"Proposed what?" they cried.</p>
<p class="calibre3">"Well, that's what I'm going to tell you if you give me half a chance.
She said she felt as if she owed something to us girls for having stood
so loyally behind Uncle Sam, and had decided to offer us her cottage at
Bluff Point to use as long as we wanted it."</p>
<p class="calibre3">"Bluff Point!" cried Betty, while her eyes began to sparkle. "Why Grace!
isn't that the place you were telling us about—"</p>
<p class="calibre3">"Where the quaint little house stands on a bluff—" added Amy eagerly.</p>
<p class="calibre3">"Overlooking a sparkling white beach that leads down to the ocean?" went
on Betty.</p>
<p class="calibre3">"The very same," nodded Grace, and they heaved a sigh of pure excitement
and happiness.</p>
<p class="calibre3">"Isn't it wonderful," cried Mollie joyfully, "how somebody is always
doing something to make us happy?"<span id="pgepubid00047" title="[29]"><a id="Page_29" title="[29]"></a></span></p>
<p class="calibre3">"Yes, but when I said that to Aunt Mary last night she smiled and looked
wise—you know how sweet she is—and said that that was the way
happiness always came to us—by helping others to be happy."</p>
<p class="calibre3">"But we haven't done anything to make anybody happy—particularly that
is," said Mollie wondering.</p>
<p class="calibre3">"I said that too," nodded Grace. "But she only went on smiling, and I
realized she must have meant our work at the Hostess House."</p>
<p class="calibre3">"It's strange how everybody persists in calling it work and giving us so
much credit when it was all such fun," said Betty. "But girls," she
added, laughing breathlessly, "the great fact is that we are going to
have another adventure in the open. The very thought of it makes me want
to roll in the buttercups."</p>
<p class="calibre3">"Goodness, there's one open in the back meadow," suggested Mollie. "You
can roll in it, if you want to."</p>
<p class="calibre3">"Well, I don't—I want a whole patch of them!" cried Betty, while the
rest laughed at Mollie's picture. "My, I feel younger already."</p>
<p class="calibre3">"Well of course you need to," drawled Grace, adding with a fond glance
at the glowing Little Captain: "You look so terribly like a dried-up
ancient, dear."<span id="pgepubid00048" title="[30]"><a id="Page_30" title="[30]"></a></span></p>
<p class="calibre3">"But when shall we start?" cried Mollie, coming back to the
all-absorbing topic at hand. "Goodness, I'd like to throw a few clothes
in a suitcase and start right away—quick—this minute—I can't wait!"</p>
<p class="calibre3">"Do you think it's catching?" asked Grace, anxiously.</p>
<p class="calibre3">"From the way I feel I should say it was already caught," twinkled
Betty, adding eagerly: "How long do you suppose we will have to wait,
Grace? Did your Aunt Mary say when we could have the cottage?"</p>
<p class="calibre3">"As soon as we want it," replied Grace, looking surprised. "Didn't I
tell you?"</p>
<p class="calibre3">"No you didn't," mimicked Mollie, adding as she sprang to her feet
impatiently: "I'd like to know what we're waiting for anyway! Why don't
we get started?"</p>
<p class="calibre3">"Now I know she's crazy," cried Betty, seizing her chum and pulling her
down upon the arm of her chair. "Why we haven't decided anything yet."</p>
<p class="calibre3">"What is there to decide?" cried Mollie, trying to be patient and
looking like a martyr.</p>
<p class="calibre3">"Why we don't even know how we're going to get there yet," explained
Betty soothingly.</p>
<p class="calibre3">"In the automobile, of course," cried Mollie, jumping up again.<span id="pgepubid00049" title="[31]"><a id="Page_31" title="[31]"></a></span></p>
<p class="calibre3">"Oh, can we?" cried Grace, forgetting to be <ins class="calibre19" title="Transcriber's Note: original reads 'lanquid'">languid</ins> and bouncing eagerly
in the swing. "Mollie, that would be wonderful."</p>
<p class="calibre3">"Why of course we'll go in the car!" it was Mollie's turn to look
surprised. "What did you think we were going to do—walk?"</p>
<p class="calibre3">"There are railroads, you know," Grace reminded her, relapsing into
irony. "And as to walking—well, we did that too before you got your
car, Mollie."</p>
<p class="calibre3">"Yes, and got sore feet," added Mollie.</p>
<p class="calibre3">"Well, now that we've decided not to go on the railroad or walk," Amy
broke in unexpectedly, "I really don't see what we are waiting for."</p>
<p class="calibre3">"My goodness, there's another lunatic," cried Grace, looking
<ins class="calibre19" title="Transcriber's Note: original reads 'dispairingly'">despairingly</ins> at the Little Captain, whose eyes twinkled merrily. "What
do you expect us to do—go just as we are?"</p>
<p class="calibre3">"No, but we can throw some things into a suitcase—"</p>
<p class="calibre3">"How long do you suppose it will take us to get there?" asked the Little
Captain, coming to Grace's rescue.</p>
<p class="calibre3">"Why, even in Mollie's car it will take two days," said Grace, turning
to Betty with the relief of one who at last had a sane person to reckon
with. "Mollie and Amy evidently expect to make it in a couple of
hours."<span id="pgepubid00050" title="[32]"><a id="Page_32" title="[32]"></a></span></p>
<p class="calibre3">"Oh well, I didn't know it was so far away," murmured Mollie, somewhat
taken aback. "Of course, then, we can't go until to-morrow."</p>
<p class="calibre3">The girls laughed merrily, and Betty hugged her.</p>
<p class="calibre3">"We might," chuckled the latter, "even be forced to wait till day after
to-morrow."</p>
<p class="calibre3">"I won't do it!" cried Mollie, jumping up again. "There's no reason in
the world why we can't start to-morrow."</p>
<p class="calibre3">"But, Mollie dear," insisted Betty mildly, "we haven't even asked our
folks whether we may go or not—"</p>
<p class="calibre3">"As if we didn't know what they will say," broke in Mollie, but Betty
went on without heeding her.</p>
<p class="calibre3">"And we must have a chaperone, you know."</p>
<p class="calibre3">"Oh, I suppose so," sighed Mollie sinking down in her chair resignedly,
"but it's horribly tiresome. I want to go now."</p>
<p class="calibre3">"You sound like Dodo with her candies," remarked Grace, <ins class="calibre19" title="Transcriber's Note: original reads 'aimably'">amiably</ins> helping
herself to a luscious milk chocolate filled with nuts. "Have one,
Mollie—it may make you feel better."</p>
<p class="calibre3">"It won't, but I will," said Mollie rather enigmatically, reaching out a
hand for the proffered sweet. "Thank you, dear."</p>
<p class="calibre3">"But whom shall we have for a chaperone?"<span id="pgepubid00051" title="[33]"><a id="Page_33" title="[33]"></a></span> cried Amy impatiently. "I'm
almost as bad as Mollie—I can hardly wait till to-morrow."</p>
<p class="calibre3">"Why," said Grace, nibbling daintily, "I thought maybe you girls
wouldn't mind if I asked mother to go with us."</p>
<p class="calibre3">"Mind!" echoed Betty, while the others looked at her in surprise. "Why
of course we'd love to have her! You know that. But I never imagined she
would care to go, she is so interested in Red Cross work and her
clubs—"</p>
<p class="calibre3">"That's just it," said Grace, sitting up quickly. "She's entirely worn
out with work and worry about Will, and I thought a little vacation with
us girls would help her out wonderfully. I'm not sure she will go—I
haven't asked her yet."</p>
<p class="calibre3">"Well, let's," cried Betty impulsively, jumping to her feet. "She simply
can't refuse if we all ask her at once."</p>
<p class="calibre3">"Now you're saying something!" cried Mollie fervently, albeit slangily,
as she flung her arm about the Little Captain and dragged her down the
steps. "Action is what we need—action, and plenty of it."</p>
<p class="calibre3">The girls fairly ran the short distance from Mollie's home to Grace's,
and the people they met on the way, greeted them heartily, musing as he
or she turned to go on: "There's probably something interesting in the
air—the Outdoor Girls<span id="pgepubid00052" title="[34]"><a id="Page_34" title="[34]"></a></span> always look like that when they have some new
adventure in tow." For Deepdale was very proud and fond of its Outdoor
Girls.</p>
<p class="calibre3">Mrs. Ford was just coming down the stairs dressed to go out when the
quartette burst in upon her. She did look very tired and worn, as Grace
had said, but the smile that lighted her face at sight of the girls made
her appear ten years younger.</p>
<p class="calibre3">"Mother," said Grace, taking one of her mother's carefully gloved hands
in her own and leading her gently but firmly into the library, "we have
something very important to say to you."</p>
<p class="calibre3">"Will it take long?" queried Mrs. Ford, smiling at the other girls over
her shoulder. "Because, if it will, I'm very much afraid I can't wait.
I'm a little late now."</p>
<p class="calibre3">"That," said Grace decidedly, as her mother sank into a chair and the
other girls grouped themselves about her, "is exactly what we have come
to talk about. We think you need a little vacation."</p>
<p class="calibre3">"Vacation!" cried the lady, half rising from her chair. "Why, my dear!
how can I take a vacation when my hands are so full of work now that I
am—"</p>
<p class="calibre3">"You don't have to take it," Grace interrupted argumentatively, "we'll
just give it to you."<span id="pgepubid00053" title="[35]"><a id="Page_35" title="[35]"></a></span></p>
<p class="calibre3">Mrs. Ford laughed helplessly and regarded the eager young faces with
amusement.</p>
<p class="calibre3">"Out with it, girls," she commanded. "I know you are plotting some
terrible thing. What do you intend to do, kidnap me?"</p>
<p class="calibre3">"No, we're keeping that for a last resort," returned Betty, and Mrs.
Ford laughed outright at the confession.</p>
<p class="calibre3">"We want," explained Grace, speaking fast for fear of being interrupted,
"to have you go with us to Bluff Point. We need a chaperone, you know."</p>
<p class="calibre3">"I've no doubt of it," retorted her mother, laughing, adding, with
another anxious glance at the clock: "But I'm afraid you will have to
get someone else, Honey. If I were free, I should like nothing better,
but you see how rushed I am—"</p>
<p class="calibre3">"But you're terribly tired, Mother, you know you are," said Grace with
unusual gentleness, adding diplomatically: "What good will you be to the
Red Cross or to anyone else, I'd like to know, if you let yourself get
sick?"</p>
<p class="calibre3">"But I'm not sick," protested her mother, then added with a sudden
longing as the wild solitude of Bluff Point rose before her eyes
suggesting utter peace and quiet, a chance to rest tired nerves and
gather strength for the last great drive:</p>
<p class="calibre3">"You're right, I am tired, terribly tired," and<span id="pgepubid00054" title="[36]"><a id="Page_36" title="[36]"></a></span> the lines of weariness
returning to her face. "I'd love it, girls, but there's my work!"</p>
<p class="calibre3">It took the girls about five minutes of the hardest work they had ever
done in their lives. But they did what they had set out to do. At the
end of that time Mrs. Ford consented to start with them whenever they
were ready.</p>
<p class="calibre3">"Day after to-morrow?" asked Mollie, her eyes shining.</p>
<p class="calibre3">"I don't know why not," said Mrs. Ford, then sprang to her feet with a
cry of dismay. "Girls, I completely forgot to telephone the Red Cross.
What will they think of me?"<span id="pgepubid00055" title="[37]"><a id="Page_37" title="[37]"></a></span></p>
<div class="pg-boilerplate" id="calibre_pb_16"></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0006.vue?64f25572